import React from 'react'
import PropTypes from 'prop-types'
import { links } from 'common/helpers'

import Box from 'components/_new/layout/Box/Box'
import Link from 'components/_new/typography/Link/Link'
import Text from 'components/_new/typography/Text/Text'

import messages from './messages'


const FooterLinks = () => {
  const items = [
    { message: messages.about, to: links.team },
    { message: messages.shopPerfumes, to: links.perfumes },
    { message: messages.shopColognes, to: links.colognes },
    { message: messages.help, href: links.faq },
  ]

  return items.map((link) => (
    <Box key={link.to || link.href} pt="12" pb="12">
      <Link
        color="white"
        withUnderline={false}
        withArrow
        to={link.to}
        href={link.href}
      >
        <Text tag="span" size="14-24" message={link.message} />
      </Link>
    </Box>
  ))
}

FooterLinks.contextTypes = {
  globals: PropTypes.object.isRequired,
}


export default FooterLinks
